import { useEffect, useContext, useCallback, useState } from "react";
import { AuthContext } from "shared/context/AuthContext";
import { getUserDisks } from "../api/ceph.api";

export const useStorageData = () => {
  const { state, setContext } = useContext(AuthContext);
  const { userProfile } = state;

  const TTL = 1000 * 60 * 5; // 5 minut

  const [storageData, setStorageData] = useState(() => {
    // wczytaj z localStorage przy inicjalizacji
    return JSON.parse(localStorage.getItem("storageData")) || null;
  });

  const [loading, setLoading] = useState(() => {
    const storedLastFetch = Number(localStorage.getItem("storageDataLastFetch")) || 0;
    return !storageData || (Date.now() - storedLastFetch > TTL);
  });

  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL
  const username = userProfile?.username;

  const fetchData = useCallback(async (force = false) => {
    if (!state.isAuthUser || !username) {
      setLoading(false);
      return;
    }
    // if (!username) return;

    const cachedLastFetch = state.storageDataLastFetch || Number(localStorage.getItem("storageDataLastFetch")) || 0;
    const isCacheValid = cachedLastFetch && Date.now() - cachedLastFetch < TTL;
    

    // 🔥 cache guard
    if (!force && isCacheValid && storageData) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getUserDisks({ apiUrl, username });

      if (response.status === "success" && response.disks.length > 0) {
        const newData = {
          disk: response.disks[0],
          summary: response.summary,
          iscsi_target: response.iscsi_target,
          nfs_exports: response.nfs_exports
        };

        setStorageData(newData);

        setContext({
          storageData: newData,
          isLoadedStorageData: true,
          storageDataLastFetch: Date.now()
        });

        localStorage.setItem("storageData", JSON.stringify(newData));
        localStorage.setItem("storageDataLastFetch", Date.now().toString());
      }
    } catch (err) {
      console.error("Disk fetch error:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [state.isAuthUser, username, apiUrl, storageData, setContext,]);

  useEffect(() => {
    if (!state.isAuthUser) {
      return;
    }

    fetchData();
  }, [state.isAuthUser, fetchData]);

  const refetch = () => {
    if (!state.isAuthUser) return;
    fetchData(true);
  };

  return {
    data: storageData,
    loading,
    error,
    refetch
  };
};